import React, { useState, useEffect, useRef, useCallback, useLayoutEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import ptBrLocale from "@fullcalendar/core/locales/pt-br";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import NovoEventoModal from "./NovoEventoModal";
import listPlugin from "@fullcalendar/list";
import FichaDeAtendimentoModal from "./FichaDeAtendimentoModal";
import { getTodosPacientes } from "./PacientesService";
import { getAllAgendamentosByUserIdETipo, alterarStatusAgendamento, atualizarInformacoesAgendamento } from "./AgendaService";
import { getFuncionarios } from "./FuncionarioService";
import { getConfiguracoesAtendimentoMedicoPorUsuario } from "./ConfiguracaoHorarioMedicoService";
import {
    formatarData,
    formatarHora,
    getDataAtendimentoEspecifico,
    getDataBloqueio,
    getDiaSemanaChave,
    isConfiguracaoBloqueio,
    isConfiguracaoEspecifica,
    isConfiguracaoSemanal,
    normalizarData,
} from "./Helpers/AgendaValidation";
import {
    getConsultasPorIdPaciente,
    getExamesFisicosPorIdPaciente,
} from "./ConsultaService";
import EditarEventoModal from "./EditarEventoModal";
import Select from "react-select";
import ConsultasFinalizadasModal from "./ConsultasFinalizadasModal";
import AgendaPorMedicoModal from "./AgendaPorMedicoModal";
import ConfiguracaoPacienteModal from "./ConfiguracaoPacienteModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCalendarDay,
    faCalendarDays,
    faPenToSquare,
    faUserCheck,
    faUserMinus,
    faCommentDots,
    faCircleCheck,
    faCircleXmark,
    faBan,
    faChartLine,
    faCircle
} from "@fortawesome/free-solid-svg-icons";
import CreatableSelect from 'react-select/creatable';

const INTERVALO_ATENDIMENTO_MINUTOS = 30;

const converterHoraParaMinutos = (hora) => {
    const [horas = 0, minutos = 0] = formatarHora(hora)
        .split(":")
        .map(Number);

    return horas * 60 + minutos;
};

const converterMinutosParaHora = (minutosTotais) => {
    const horas = Math.floor(minutosTotais / 60);
    const minutos = minutosTotais % 60;

    return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(
        2,
        "0",
    )}`;
};

const gerarHorariosNoIntervalo = (horaInicio, horaFim) => {
    const inicio = converterHoraParaMinutos(horaInicio);
    const fim = converterHoraParaMinutos(horaFim);
    const horarios = [];

    for (
        let horario = inicio;
        horario <= fim;
        horario += INTERVALO_ATENDIMENTO_MINUTOS
    ) {
        horarios.push(converterMinutosParaHora(horario));
    }

    return horarios;
};

const Agenda = ({ authResponseDTO, token }) => {
    const [modalNovoAtendimentoOpen, setModalNovoAtendimentoOpen] =
        useState(false);
    const [modalEditarAtendimentoOpen, setModalEditarAtendimentoOpen] =
        useState(false);
    const [
        modalFichaDeAtendimentoModalOpen,
        setModalFichaDeAtendimentoModalOpen,
    ] = useState(false);
    const [modalAgendaPorMedico, setModalAgendaPorMedico] = useState(false);
    const [pacientes, setPacientes] = useState([]);
    const [pacienteSelecionadoNaAgenda, setPacienteSelecionadoNaAgenda] =
        useState(null);
    const [events, setEvents] = useState([]);
    const [funcionarios, setFuncionarios] = useState([]);
    const [consultasPorIdPaciente, setConsultasPorIdPaciente] = useState([]);
    const [consultasPacienteModal, setConsultasPacienteModal] = useState([]);
    const [
        consultasParaGraficosPorIdPaciente,
        setConsultasParaGraficosPorIdPaciente,
    ] = useState([]);
    const [selectDate, setSelectDate] = useState(null);
    const [statusAgenda, setStatusAgenda] = useState("");
    const [idAgenda, setIdAgenda] = useState("");
    const [funcionarioDoEventoSelecionado, setFuncionarioDoEventoSelecionado] =
        useState(null);
    const [tipoConsulta, setTipoConsulta] = useState("");
    const [observacao, setObservacao] = useState("");
    const [eventInfo, setEventInfo] = useState([]);
    const [isEditavel, setIsEdtitavel] = useState(false);
    const [titulo, setTitulo] = useState("");
    const [funcionarioSelecionado, setFuncionarioSelecionado] = useState("");
    const [modalConsultasFinalizadasOpen, setModalConsultasFinalizadasOpen] =
        useState(false);
    const [modalPacienteOpen, setModalPacienteOpen] = useState(false);
    const [pacienteParaEditar, setPacienteParaEditar] = useState(null);
    const [isButtonStaticPaciente, setIsButtonStaticPaciente] = useState(true);
    const [headerToolBarLeft, setHeaderToolBarLeft] = useState("");
    const [customButton, setCustomButton] = useState({});
    const [dataSelecionada, setDataSelecionada] = useState("");
    const [horaSelecionada, setHoraSelecionada] = useState("");
    const [configuracoesAtendimento, setConfiguracoesAtendimento] = useState([]);
    const [carregandoConfiguracoesAtendimento, setCarregandoConfiguracoesAtendimento] =
        useState(false);
    const [disponibilidadeSelecionada, setDisponibilidadeSelecionada] =
        useState(null);

    const getProfissionalEmFoco = useCallback(() => {
        if (authResponseDTO.funcao === "RECEPCIONISTA") {
            return funcionarioSelecionado || null;
        }

        return authResponseDTO;
    }, [authResponseDTO, funcionarioSelecionado]);

    const openModalNovoAtendimento = (info) => {
        setTitulo("Adicionar na agenda");
        setDataSelecionada(info.dateStr);
        setHoraSelecionada(info.horaStr || "");
        setEventInfo([]);
        setIsEdtitavel(false);
        setModalNovoAtendimentoOpen(true);
    };

    const openModalConsultasFinalizadas = (info) => {
        setModalConsultasFinalizadasOpen(true);
    };

    const openModalAgendaPorMedico = (info) => {
        setModalAgendaPorMedico(true);
    };

    const agendamentosIntervalRef = useRef(null);

    const [contextMenu, setContextMenu] = useState({
        visible: false,
        x: 0,
        y: 0,
        eventInfo: null, // Store event data for context menu actions
    });
    const contextMenuRef = useRef(null);

    const fetchAgendamentos = useCallback(() => {
        getAllAgendamentosByUserIdETipo(
            token,
            authResponseDTO.id,
            authResponseDTO.funcao,
        )
            .then((response) => {
                setEvents(response);
            })
            .catch((error) => {
                console.error("Erro ao acessar a API:", error);
            });
    }, [token, authResponseDTO.id, authResponseDTO.funcao]);

    const contextMenuActions = {
        confirmar: { label: "Confirmar", status: "CONFIRMADA", icon: faCircleCheck, iconClass: "text-green-600" },
        faltou: { label: "Faltou", status: "FALTA", icon: faCircleXmark, iconClass: "text-red-700" },
        cancelar: { label: "Cancelar", status: "CANCELADA", icon: faBan, iconClass: "text-gray-500" },
    };

    const getPacienteDoEvento = (eventoSelecionado) =>
        eventoSelecionado?.extendedProps?.paciente ??
        eventoSelecionado?.extendedProps?.pacientes ??
        eventoSelecionado?.paciente ??
        eventoSelecionado?.pacientes;

    const abrirModalParaEditarPaciente = () => {
        const pacienteDoEvento = getPacienteDoEvento(contextMenu.eventInfo);

        if (!pacienteDoEvento?.id) {
            alert("Não foi possível identificar o paciente deste agendamento.");
            return;
        }

        setConsultasPacienteModal([]);
        setIsButtonStaticPaciente(true);
        setPacienteParaEditar(pacienteDoEvento);
        setModalPacienteOpen(true);
        setContextMenu((prev) => ({ ...prev, visible: false }));
    };

    const handleContextMenuStatus = async (statusSelecionado) => {
        try {
            const agendamentoId = contextMenu.eventInfo?._def?.publicId;

            if (!agendamentoId) {
                console.warn("Nenhum agendamento selecionado para alterar status.");
                return;
            }

            await alterarStatusAgendamento(agendamentoId, token, statusSelecionado);
            setContextMenu((prev) => ({ ...prev, visible: false }));
            fetchAgendamentos();
            window.location.reload(); // Recarrega a página para garantir que o modal de edição leia o status atualizado.
        } catch (error) {
            console.error("Erro ao alterar status via menu de contexto:", error);
        }
    };

    const handleContextMenuCheckIn = async () => {
        try {
            const eventoSelecionado = contextMenu.eventInfo;

            if (!eventoSelecionado?._def?.publicId) {
                console.warn("Nenhum agendamento selecionado para alterar o check-in.");
                return;
            }

            const extendedProps = eventoSelecionado.extendedProps || {};
            const novoCheckIn = !extendedProps.checkIn;

            const payload = {
                paciente: extendedProps.paciente?.id ?? "",
                dataDaConsulta: extendedProps.dataDaConsulta ?? "",
                horaDaConsulta: extendedProps.horaDaConsulta ?? "",
                funcionario: extendedProps.usuario?.id ?? "",
                statusAgenda: extendedProps.statusAgenda ?? "AGUARDANDO",
                observacao: extendedProps.observacao ?? "",
                tipoConsulta: extendedProps.tipoConsulta ?? "",
                checkIn: novoCheckIn,
            };

            await atualizarInformacoesAgendamento(eventoSelecionado._def.publicId, token, payload);
            setContextMenu((prev) => ({ ...prev, visible: false }));
            fetchAgendamentos();
            window.location.reload(); // garante que o modal enxergue o novo check-in.
        } catch (error) {
            console.error("Erro ao alterar check-in via menu de contexto:", error);
        }
    };

    const handleEnviarConfirmacaoWhatsApp = () => {
        const eventoSelecionado = contextMenu.eventInfo;

        if (!eventoSelecionado) {
            console.warn("Nenhum agendamento selecionado para enviar confirmação via WhatsApp.");
            return;
        }

        const pacienteDoEvento = getPacienteDoEvento(eventoSelecionado);

        const responsaveis = pacienteDoEvento?.responsaveis ?? [];
        const responsavelPreferencial = responsaveis[1] || responsaveis[0];
        const telefoneResponsavel = responsavelPreferencial?.telefone ?? "";

        const telefoneLimpo = telefoneResponsavel.replace(/\D/g, "");

        if (!telefoneLimpo) {
            alert("Não foi possível encontrar o telefone do responsável para enviar a confirmação.");
            return;
        }

        const telefoneComDdi = telefoneLimpo.startsWith("55")
            ? telefoneLimpo
            : `55${telefoneLimpo}`;

        const dataConsulta =
            eventoSelecionado.start
                ? eventoSelecionado.start.toLocaleDateString("pt-BR", {
                    timeZone: "America/Sao_Paulo",
                })
                : eventoSelecionado.extendedProps?.dataDaConsulta ?? "";

        const horarioConsulta =
            eventoSelecionado.start
                ? eventoSelecionado.start.toLocaleTimeString("pt-BR", {
                    hour: "2-digit",
                    minute: "2-digit",
                    timeZone: "America/Sao_Paulo",
                })
                : eventoSelecionado.extendedProps?.horaDaConsulta ?? "";

        if (!dataConsulta || !horarioConsulta) {
            alert("Não foi possível identificar a data e o horário da consulta.");
            return;
        }

        const nomePaciente = pacienteDoEvento?.nome ?? "o paciente";
        const mensagem = `Olá! Confirmamos a consulta de ${nomePaciente} para o dia ${dataConsulta} às ${horarioConsulta}. Por favor, responda para confirmar o comparecimento.`;
        const url = `https://web.whatsapp.com/send?phone=${telefoneComDdi}&text=${encodeURIComponent(mensagem)}`;

        window.open(url, "_blank", "noopener,noreferrer");
        setContextMenu((prev) => ({ ...prev, visible: false }));
    };

    useEffect(() => {
        getTodosPacientes(token)
            .then((response) => {
                setPacientes(response);
            })
            .catch((error) => {
                console.error("Erro ao acessar a API:", error);
            });
    }, []);

    useEffect(() => {
        fetchAgendamentos();
        agendamentosIntervalRef.current = setInterval(fetchAgendamentos, 30000);

        return () => {
            clearInterval(agendamentosIntervalRef.current);
        };
    }, [fetchAgendamentos]);

    useEffect(() => {
        if (!contextMenu.visible) {
            return;
        }

        const handleGlobalMouseDown = (event) => {
            const menuElement = document.getElementById("context-menu-agenda");

            if (menuElement && !menuElement.contains(event.target)) {
                setContextMenu((prev) => ({ ...prev, visible: false }));
            }
        };

        window.addEventListener("mousedown", handleGlobalMouseDown);

        return () => {
            window.removeEventListener("mousedown", handleGlobalMouseDown);
        };
    }, [contextMenu.visible]);

    useLayoutEffect(() => {
        if (!contextMenu.visible) {
            return;
        }

        const menuElement = contextMenuRef.current;

        if (!menuElement) {
            return;
        }

        const rect = menuElement.getBoundingClientRect();
        const padding = 8;
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;
        let nextX = contextMenu.x;
        let nextY = contextMenu.y;

        if (nextX + rect.width + padding > viewportWidth) {
            nextX = Math.max(padding, viewportWidth - rect.width - padding);
        }

        if (nextY + rect.height + padding > viewportHeight) {
            nextY = Math.max(padding, nextY - rect.height);
        }

        if (nextX !== contextMenu.x || nextY !== contextMenu.y) {
            setContextMenu((prev) => ({ ...prev, x: nextX, y: nextY }));
        }
    }, [contextMenu.visible, contextMenu.x, contextMenu.y]);

    useEffect(() => {
        getFuncionarios(token)
            .then((response) => {
                // debugger;
                setFuncionarios(response.filter(resp => resp.id === 15 || resp.id === 16 || resp.id === 81272));
            })
            .catch((error) => {
                console.error("Erro ao acessar a API:", error);
            });
    }, []);

    useEffect(() => {
        const profissional = getProfissionalEmFoco();

        if (!profissional?.id) {
            setConfiguracoesAtendimento([]);
            setDisponibilidadeSelecionada(null);
            return;
        }

        let ativo = true;

        const carregarConfiguracoesAtendimento = async () => {
            setCarregandoConfiguracoesAtendimento(true);
            try {
                const configuracoes =
                    await getConfiguracoesAtendimentoMedicoPorUsuario(
                        token,
                        profissional.id,
                    );

                if (ativo) {
                    setConfiguracoesAtendimento(
                        Array.isArray(configuracoes) ? configuracoes : [],
                    );
                    setDisponibilidadeSelecionada(null);
                }
            } catch (error) {
                console.error(
                    "Erro ao carregar configuracoes de atendimento:",
                    error,
                );
                if (ativo) {
                    setConfiguracoesAtendimento([]);
                    setDisponibilidadeSelecionada(null);
                }
            } finally {
                if (ativo) {
                    setCarregandoConfiguracoesAtendimento(false);
                }
            }
        };

        carregarConfiguracoesAtendimento();

        return () => {
            ativo = false;
        };
    }, [getProfissionalEmFoco, token]);

    useEffect(() => {
        if (authResponseDTO.funcao !== "RECEPCIONISTA") {
            setCustomButton({
                myCustomButton: {
                    text: "+ Agendar",
                    click: openModalNovoAtendimento,
                },
                consultasFinalizadas: {
                    text: "Finalizadas",
                    click: openModalConsultasFinalizadas,
                },
            });

            setHeaderToolBarLeft(
                window.innerWidth < 640
                    ? ""
                    : "timeGridDay,timeGridWeek,dayGridMonth,listMonth consultasFinalizadas",
            );
        } else {
            setCustomButton({
                myCustomButton: {
                    text: "+ Agendar",
                    click: openModalNovoAtendimento,
                },
                consultasPorMedico: {
                    text: "Filtrar por médico",
                    click: openModalAgendaPorMedico,
                },
                consultasFinalizadas: {
                    text: "Finalizadas",
                    click: openModalConsultasFinalizadas,
                },
            });

            setHeaderToolBarLeft(
                window.innerWidth < 640
                    ? ""
                    : "timeGridDay,timeGridWeek,dayGridMonth,listMonth consultasPorMedico,consultasFinalizadas",
            );
        }
    }, []);

    const closeModal = () => {
        setModalNovoAtendimentoOpen(false);
    };

    const closeModalPaciente = () => {
        setModalPacienteOpen(false);
        setPacienteParaEditar(null);
    };

    const closeModalFichaDeAtendimentoModalOpen = () => {
        setModalFichaDeAtendimentoModalOpen(false);
    };

    const setConsultaSelecionada = (idPaciente) => {
        getExamesFisicosPorIdPaciente(idPaciente, token)
            .then((response) => {
                setConsultasParaGraficosPorIdPaciente(response);
            })
            .catch((error) => {
                setConsultasParaGraficosPorIdPaciente(null);
                console.error("Erro ao acessar a API:", error);
            });

        getConsultasPorIdPaciente(idPaciente, token)
            .then((response) => {
                setConsultasPorIdPaciente(response);
            })
            .catch((error) => {
                console.error("Erro ao acessar a API:", error);
            });
    };

    const defaultView = window.innerWidth < 640 ? "listMonth" : "dayGridMonth";

    const handleSelectChange = (e) => {
        clearInterval(agendamentosIntervalRef.current);
        setFuncionarioSelecionado(e);

        getAllAgendamentosByUserIdETipo(
            token,
            // funcionarioSelecionado.id,
            // funcionarioSelecionado.funcao,
            e.id,
            e.funcao,
        )
            .then((response) => {
                setEvents(response);
            })
            .catch((error) => {
                console.error("Erro ao acessar a API:", error);
            });
    };

    const getAgendamentosDaData = useCallback(
        (data) => {
            const dataNormalizada = normalizarData(data);

            return events.filter((event) => {
                const dataEvento = normalizarData(
                    event.extendedProps?.dataDaConsulta ??
                        event.dataDaConsulta ??
                        event.start,
                );

                return dataEvento === dataNormalizada;
            });
        },
        [events],
    );

    const getConfiguracaoAtendimentoParaData = useCallback(
        (data) => {
            const dataNormalizada = normalizarData(data);
            const bloqueado = configuracoesAtendimento.some(
                (configuracao) =>
                    isConfiguracaoBloqueio(configuracao) &&
                    getDataBloqueio(configuracao) === dataNormalizada,
            );

            if (bloqueado) {
                return {
                    podeAtender: false,
                    bloqueado: true,
                    motivo: "Dia bloqueado pelo profissional.",
                    configuracoes: [],
                };
            }

            const configuracoesEspecificas =
                configuracoesAtendimento.filter(
                    (configuracao) =>
                        isConfiguracaoEspecifica(configuracao) &&
                        getDataAtendimentoEspecifico(configuracao) ===
                            dataNormalizada,
                );

            if (configuracoesEspecificas.length > 0) {
                return {
                    podeAtender: true,
                    bloqueado: false,
                    configuracoes: configuracoesEspecificas,
                };
            }

            const diaSemana = getDiaSemanaChave(dataNormalizada);
            const configuracoesSemanais = configuracoesAtendimento.filter(
                (configuracao) =>
                    isConfiguracaoSemanal(configuracao) &&
                    configuracao.diasDaSemana === diaSemana,
            );

            if (configuracoesSemanais.length > 0) {
                return {
                    podeAtender: true,
                    bloqueado: false,
                    configuracoes: configuracoesSemanais,
                };
            }

            return {
                podeAtender: false,
                bloqueado: false,
                motivo: "O profissional não atende nesta data.",
                configuracoes: [],
            };
        },
        [configuracoesAtendimento],
    );

    const getHorariosDisponiveisDaData = useCallback(
        (data) => {
            const disponibilidade = getConfiguracaoAtendimentoParaData(data);

            if (!disponibilidade.podeAtender) {
                return {
                    ...disponibilidade,
                    horarios: [],
                    horariosOcupados: [],
                };
            }

            const horariosConfigurados = disponibilidade.configuracoes.flatMap(
                (configuracao) =>
                    gerarHorariosNoIntervalo(
                        configuracao.horaInicio,
                        configuracao.horaFim,
                    ),
            );
            const horariosOcupados = getAgendamentosDaData(data).map(
                (agendamento) =>
                    formatarHora(
                        agendamento.extendedProps?.horaDaConsulta ??
                            agendamento.horaDaConsulta,
                    ),
            );
            const horariosDisponiveis = Array.from(
                new Set(
                    horariosConfigurados.filter(
                        (horario) => !horariosOcupados.includes(horario),
                    ),
                ),
            ).sort();

            return {
                ...disponibilidade,
                horarios: horariosDisponiveis,
                horariosOcupados,
            };
        },
        [getAgendamentosDaData, getConfiguracaoAtendimentoParaData],
    );

    const handleDateClick = (info) => {
        const profissional = getProfissionalEmFoco();

        if (!profissional?.id) {
            alert("Selecione o médico para consultar os horários disponíveis.");
            return;
        }

        const dataSelecionadaClick = normalizarData(info.dateStr);
        const disponibilidade = getHorariosDisponiveisDaData(
            dataSelecionadaClick,
        );

        if (!disponibilidade.podeAtender) {
            setDisponibilidadeSelecionada({
                data: dataSelecionadaClick,
                profissional,
                ...disponibilidade,
            });
            return;
        }

        setDisponibilidadeSelecionada({
            data: dataSelecionadaClick,
            profissional,
            ...disponibilidade,
        });
    };

    const agendarHorarioDisponivel = (horario) => {
        if (!disponibilidadeSelecionada?.data) {
            return;
        }

        openModalNovoAtendimento({
            dateStr: disponibilidadeSelecionada.data,
            horaStr: horario,
        });
    };

    const getDayCellClassNames = useCallback(
        (arg) => {
            const profissional = getProfissionalEmFoco();

            if (!profissional?.id || carregandoConfiguracoesAtendimento) {
                return [];
            }

            const data = normalizarData(arg.date.toISOString());
            const disponibilidade = getConfiguracaoAtendimentoParaData(data);

            if (disponibilidade.bloqueado) {
                return ["agenda-dia-bloqueado"];
            }

            if (!disponibilidade.podeAtender) {
                return ["agenda-dia-sem-atendimento"];
            }

            return ["agenda-dia-disponivel"];
        },
        [
            carregandoConfiguracoesAtendimento,
            getConfiguracaoAtendimentoParaData,
            getProfissionalEmFoco,
        ],
    );

    const abrirModalParaEditarAtendimento = (info) => {
        alert("Deseja editar?");
        setEventInfo(info);
        setModalEditarAtendimentoOpen(true);
    };

    const isRecepcionista = () => {
        return authResponseDTO.funcao === "RECEPCIONISTA"
    }

    const handleEventDidMount = (info) => {
        info.el.addEventListener('contextmenu', (e) => {
            e.preventDefault(); // Prevent default browser context menu
            setContextMenu({
                visible: true,
                x: e.clientX,
                y: e.clientY,
                eventInfo: info.event,
                info: info,
            });
        });
    };

    return (
        <>
            <section className="bg-gray-900 dark:bg-gray-900 p-3 sm:p-5 w-full h-full section">
                <div className="mx-auto px-4 lg:px-12">
                    <div className="bg-white dark:bg-gray-800 relative shadow-md sm:rounded-lg overflow-hidden">
                        <div class="flex flex-wrap items-center justify-between mx-auto p-4">
                            <h1 className="text-3xl font-bold text-gray-900 ml-5 mt-5">
                                <FontAwesomeIcon
                                    className="mr-1"
                                    icon={faCalendarDays}
                                />{" "}
                                Agenda
                            </h1>
                            {isRecepcionista() && (
                                <div className="w-96">
                                    <Select
                                        onChange={handleSelectChange}
                                        maxMenuHeight={90}
                                        options={funcionarios}
                                        placeholder="Selecione o médico"
                                        required
                                    />
                                </div>
                            )}
                        </div>
                        <div className="p-3">
                            <FullCalendar
                                height={600}
                                locale={ptBrLocale}
                                eventColor={"green"}
                                plugins={[
                                    dayGridPlugin,
                                    interactionPlugin,
                                    timeGridPlugin,
                                    listPlugin,
                                ]}
                                initialView={defaultView}
                                weekends={true}
                                events={events}
                                eventDidMount={handleEventDidMount}
                                eventClick={(info) => {
                                    if (
                                        "RECEPCIONISTA".includes(
                                            authResponseDTO.funcao,
                                        )
                                    ) {
                                        abrirModalParaEditarAtendimento(info);
                                        return;
                                    }

                                    if (
                                        window.confirm(
                                            `Gostaria de iniciar o atendimento para ${info.event.title}?`,
                                        )
                                    ) {
                                        setObservacao(
                                            info.event.extendedProps.observacao,
                                        );
                                        setTipoConsulta(
                                            info.event.extendedProps
                                                .tipoConsulta,
                                        );
                                        setFuncionarioDoEventoSelecionado(
                                            info.event.extendedProps.usuario,
                                        );
                                        setStatusAgenda(
                                            info.event.extendedProps
                                                .statusAgenda,
                                        );
                                        setIdAgenda(info.event.id);
                                        setModalFichaDeAtendimentoModalOpen(
                                            true,
                                        );
                                        setPacienteSelecionadoNaAgenda(
                                            info.event.extendedProps.paciente,
                                        );
                                        setConsultaSelecionada(
                                            info.event.extendedProps.paciente
                                                .id,
                                        );
                                    }
                                }}
                                dateClick={handleDateClick}
                                dayCellClassNames={getDayCellClassNames}
                                headerToolbar={{
                                    left: headerToolBarLeft,
                                    center: "title",
                                    right: "myCustomButton,prev,next",
                                }}
                                selectable={true}
                                timeZone="America/Sao_Paulo"
                                dayMaxEventRows={2}
                                titleFormat={{
                                    year: "numeric",
                                    month: "short",
                                }}
                                customButtons={customButton}
                            />
                        </div>
                        <AgendaPorMedicoModal
                            events={events}
                            isModalOpen={modalAgendaPorMedico}
                            onCloseModal={() => setModalAgendaPorMedico(false)}
                            funcionarios={funcionarios}
                            abrirModalParaEditarAtendimento={
                                abrirModalParaEditarAtendimento
                            }
                        />
                        <ConsultasFinalizadasModal
                            funcionarios={funcionarios}
                            token={token}
                            authResponseDTO={authResponseDTO}
                            isModalOpen={modalConsultasFinalizadasOpen}
                            onCloseModal={() =>
                                setModalConsultasFinalizadasOpen(false)
                            }
                        />
                        <NovoEventoModal
                            titulo={titulo}
                            isEditando={isEditavel}
                            eventInfo={eventInfo}
                            token={token}
                            isModalOpen={modalNovoAtendimentoOpen}
                            onCloseModal={closeModal}
                            pacientes={pacientes}
                            funcionarios={funcionarios}
                            dataSelecionada={dataSelecionada}
                            horaSelecionada={horaSelecionada}
                            funcionarioPreSelecionado={getProfissionalEmFoco()}
                        />
                        <EditarEventoModal
                            eventInfo={eventInfo}
                            token={token}
                            isModalOpen={modalEditarAtendimentoOpen}
                            onCloseModal={() =>
                                setModalEditarAtendimentoOpen(false)
                            }
                            pacientes={pacientes}
                            funcionarios={funcionarios}
                        />
                        <FichaDeAtendimentoModal
                            observacao={observacao}
                            tipoConsulta={tipoConsulta}
                            idAgenda={idAgenda}
                            statusAgenda={statusAgenda}
                            token={token}
                            authResponseDTO={authResponseDTO}
                            funcionarioDoEventoSelecionado={
                                funcionarioDoEventoSelecionado
                            }
                            consultasPorIdPaciente={consultasPorIdPaciente}
                            paciente={pacienteSelecionadoNaAgenda}
                            isModalOpen={modalFichaDeAtendimentoModalOpen}
                            onCloseModal={closeModalFichaDeAtendimentoModalOpen}
                            consultasParaGraficosPorIdPaciente={
                                consultasParaGraficosPorIdPaciente
                            }
                        />
                        <ConfiguracaoPacienteModal
                            authResponseDTO={authResponseDTO}
                            consultasPorIdPaciente={consultasPacienteModal}
                            setConsultasPorIdPaciente={setConsultasPacienteModal}
                            isButtonStatic={isButtonStaticPaciente}
                            setIsButtonStatic={setIsButtonStaticPaciente}
                            token={token}
                            onModalClose={closeModalPaciente}
                            modalOpen={modalPacienteOpen}
                            titulo="Editar cadastro do paciente"
                            isEditar={true}
                            paciente={pacienteParaEditar}
                            exibeHistorico={true}
                        />
                        <ul class="flex flex-wrap items-center justify-center text-gray-900 dark:text-white mb-4">
                            <li class="me-4">
                                <FontAwesomeIcon
                                    style={{color: "#4169E1"}}
                                    className="mr-1 text-xs"
                                    icon={faCircle}
                                /> Check-in
                            </li>
                            <li class="me-4">
                                <FontAwesomeIcon
                                    style={{color: "#008000"}}
                                    className="mr-1 text-xs"
                                    icon={faCircle}
                                /> Confirmada
                            </li>
                            <li class="me-4">
                                <FontAwesomeIcon
                                    style={{color: "#8B0000"}}
                                    className="mr-1 text-xs"
                                    icon={faCircle}
                                /> Falta
                            </li>
                            <li class="me-4">
                                <FontAwesomeIcon
                                    style={{color: "#FFD700"}}
                                    className="mr-1 text-xs"
                                    icon={faCircle}
                                /> Aguardando
                            </li>
                        </ul>
                        {contextMenu.visible && (
                            <div
                                id="context-menu-agenda"
                                ref={contextMenuRef}
                                style={{
                                    position: 'fixed',
                                    top: contextMenu.y,
                                    left: contextMenu.x,
                                    background: 'white',
                                    border: '1px solid #ccc',
                                    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                    zIndex: 10000,
                                }}
                                onMouseLeave={() => setContextMenu({ ...contextMenu, visible: false })} // Hide on mouse leave
                            >
                                <ul className="context-menu-list">
                                    <li
                                        className="context-menu-item px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                        onClick={() =>
                                            abrirModalParaEditarAtendimento(contextMenu.info)
                                        }
                                    >
                                        <FontAwesomeIcon className="mr-2 text-blue-600" icon={faPenToSquare} />
                                        Editar
                                    </li>
                                    <li
                                        className="context-menu-item px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                        onClick={abrirModalParaEditarPaciente}
                                    >
                                        <FontAwesomeIcon className="mr-2 text-cyan-600" icon={faPenToSquare} />
                                        Editar cadastro do paciente
                                    </li>
                                    <li
                                        className="context-menu-item px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                        onClick={handleContextMenuCheckIn}
                                    >
                                        <FontAwesomeIcon
                                            className={`mr-2 ${contextMenu.eventInfo?.extendedProps?.checkIn ? "text-red-600" : "text-green-600"}`}
                                            icon={
                                                contextMenu.eventInfo?.extendedProps?.checkIn
                                                    ? faUserMinus
                                                    : faUserCheck
                                            }
                                        />
                                        {contextMenu.eventInfo?.extendedProps?.checkIn ? "Remover check-in" : "Realizar check-in"}
                                    </li>
                                    <li
                                        className="context-menu-item px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                        onClick={handleEnviarConfirmacaoWhatsApp}
                                    >
                                        <FontAwesomeIcon className="mr-2 text-green-600" icon={faCommentDots} />
                                        Confirmar WhatsApp
                                    </li>
                                    {Object.values(contextMenuActions).map((acao) => (
                                        <li
                                            key={acao.status}
                                            className="context-menu-item px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                            onClick={() => handleContextMenuStatus(acao.status)}
                                        >
                                            <FontAwesomeIcon className={`mr-2 ${acao.iconClass}`} icon={acao.icon} />
                                            {acao.label}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {disponibilidadeSelecionada && (
                            <div className="mx-3 mb-5 rounded-lg border border-gray-200 bg-gray-50 p-4">
                                <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
                                    <div>
                                        <h2 className="text-base font-bold text-slate-900">
                                            Horários disponíveis em{" "}
                                            {formatarData(
                                                disponibilidadeSelecionada.data,
                                            )}
                                        </h2>
                                        <p className="text-sm text-slate-600">
                                            {disponibilidadeSelecionada
                                                .profissional?.nomeSobrenome ||
                                                disponibilidadeSelecionada
                                                    .profissional?.username ||
                                                "Profissional selecionado"}
                                        </p>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() =>
                                            setDisponibilidadeSelecionada(null)
                                        }
                                        className="self-start rounded-md border border-gray-300 bg-white px-3 py-1 text-sm font-semibold text-slate-700 hover:bg-gray-100"
                                    >
                                        Fechar
                                    </button>
                                </div>

                                {!disponibilidadeSelecionada.podeAtender ? (
                                    <p className="mt-3 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
                                        {disponibilidadeSelecionada.motivo}
                                    </p>
                                ) : disponibilidadeSelecionada.horarios.length >
                                  0 ? (
                                    <div className="mt-3 flex flex-wrap gap-2">
                                        {disponibilidadeSelecionada.horarios.map(
                                            (horario) => (
                                                <button
                                                    key={horario}
                                                    type="button"
                                                    onClick={() =>
                                                        agendarHorarioDisponivel(
                                                            horario,
                                                        )
                                                    }
                                                    className="rounded-md border border-cyan-200 bg-white px-3 py-2 text-sm font-semibold text-cyan-700 hover:bg-cyan-50"
                                                >
                                                    {horario}
                                                </button>
                                            ),
                                        )}
                                    </div>
                                ) : (
                                    <p className="mt-3 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-700">
                                        Não há horários livres para esta data.
                                    </p>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Agenda;
